"use strict";
// When defining constants, keep the following in mind:
// 1. The constant name should be in TitleCase.
// 2. The keys must be UPPERCASE and the values must be lowercase.
// 3. Keep the metric keys first and the imperial keys second.
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteResponse = exports.InviteStatus = exports.VerificationStatus = exports.UserAccountStatus = exports.TransformationStatus = exports.Help = exports.Gender = exports.PostPrivacy = exports.UnitPreferences = exports.Time = exports.Length = exports.Weight = exports.Unit = exports.ImageAngle = exports.AllTrackableMeasurements = exports.ActivitySpecificMeasurement = exports.BodyMeasurement = exports.Accreditation = exports.Supplement = exports.Activity = exports.Diet = exports.Goal = exports.UITheme = exports.ServiceRate = exports.ServiceType = exports.AuthProvider = exports.Role = exports.BusinessType = exports.AccountType = void 0;
var AccountType;
(function (AccountType) {
    AccountType["INDIVIDUAL"] = "individual";
    AccountType["TRAINER"] = "trainer";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var BusinessType;
(function (BusinessType) {
    BusinessType["PERSONAL_TRAINER"] = "personal_trainer";
    BusinessType["FITNESS_BUSINESS"] = "fitness_business";
    BusinessType["FITNESS_PLAN"] = "fitness_plan";
    BusinessType["FITNESS_APP"] = "fitness_app";
})(BusinessType = exports.BusinessType || (exports.BusinessType = {}));
var Role;
(function (Role) {
    Role["USER"] = "user";
    Role["ADMIN"] = "admin";
})(Role = exports.Role || (exports.Role = {}));
var AuthProvider;
(function (AuthProvider) {
    AuthProvider["EMAIL_PASSWORD"] = "email_password";
    AuthProvider["GOOGLE"] = "google";
})(AuthProvider = exports.AuthProvider || (exports.AuthProvider = {}));
var ServiceType;
(function (ServiceType) {
    ServiceType["IN_PERSON"] = "in_person";
    ServiceType["ONLINE"] = "online";
})(ServiceType = exports.ServiceType || (exports.ServiceType = {}));
var ServiceRate;
(function (ServiceRate) {
    ServiceRate["FIXED"] = "fixed";
    ServiceRate["HOURLY"] = "hourly";
})(ServiceRate = exports.ServiceRate || (exports.ServiceRate = {}));
var UITheme;
(function (UITheme) {
    UITheme["LIGHT"] = "light";
    UITheme["DARK"] = "dark";
})(UITheme = exports.UITheme || (exports.UITheme = {}));
var Goal;
(function (Goal) {
    Goal["WEIGHT_LOSS"] = "weight_loss";
    Goal["IMPROVE_FITNESS"] = "improve_fitness";
    Goal["WEIGHT_GAIN"] = "weight_gain";
    Goal["NO_GOAL"] = "no_goal";
})(Goal = exports.Goal || (exports.Goal = {}));
var Diet;
(function (Diet) {
    Diet["CARNIVORE"] = "carnivore";
    Diet["KETO"] = "keto";
    Diet["PALEO"] = "paleo";
    Diet["VEGAN"] = "vegan";
    Diet["VEGETARIAN"] = "vegetarian";
    Diet["INTERMITTENT_FASTING"] = "intermittent_fasting";
    Diet["VERTICAL_DIET"] = "vertical_diet";
})(Diet = exports.Diet || (exports.Diet = {}));
var Activity;
(function (Activity) {
    Activity["BODYBUILDING"] = "bodybuilding";
    Activity["BOXING"] = "boxing";
    Activity["CALISTHENICS"] = "calisthenics";
    Activity["CROSSFIT"] = "crossfit";
    Activity["CYCLING"] = "cycling";
    Activity["HIIT"] = "hiit";
    Activity["PILATES"] = "pilates";
    Activity["POWERLIFTING"] = "powerlifting";
    Activity["ROWING"] = "rowing";
    Activity["PELOTON"] = "peloton";
    Activity["RUNNING"] = "running";
    Activity["SWIMMING"] = "swimming";
    Activity["WEIGHTLIFTING"] = "weightlifting";
    Activity["YOGA"] = "yoga";
    Activity["ZUMBA"] = "zumba";
})(Activity = exports.Activity || (exports.Activity = {}));
var Supplement;
(function (Supplement) {
    Supplement["HTP"] = "htp";
    Supplement["AAKG"] = "aakg";
    Supplement["ALA"] = "ala";
    Supplement["BCAA"] = "bcaa";
    Supplement["BETA_ALANINE"] = "beta_alanine";
    Supplement["CARNATINE"] = "carnatine";
    Supplement["CASEIN_PROTEIN"] = "casein_protein";
    Supplement["CITRULLINE"] = "citrulline";
    Supplement["CLA"] = "cla";
    Supplement["COD_LIVER_OIL"] = "cod_liver_oil";
    Supplement["COLLAGEN"] = "collagen";
    Supplement["COQ10"] = "coq10";
    Supplement["CREATINE"] = "creatine";
    Supplement["D_ASPARTIC_ACID"] = "d_aspartic_acid";
    Supplement["EAA"] = "eaa";
    Supplement["FOLIC_ACID"] = "folic_acid";
    Supplement["GLUCOSAMINE"] = "glucosamine";
    Supplement["GLYCINE"] = "glycine";
    Supplement["GREEN_TEA_EXTRACT"] = "green_tea_extract";
    Supplement["HEMP_PROTEIN"] = "hemp_protein";
    Supplement["HMB"] = "hmb";
    Supplement["IRON"] = "iron";
    Supplement["L_GLUTAMINE"] = "l_glutamine";
    Supplement["L_LYSINE"] = "l_lysine";
    Supplement["MACA"] = "maca";
    Supplement["MAGNESIUM"] = "magnesium";
    Supplement["MULTIVITAMIN"] = "multivitamin";
    Supplement["NAC"] = "nac";
    Supplement["OMEGA_3_FISH_OIL"] = "omega_3_fish_oil";
    Supplement["PEA_PROTEIN"] = "pea_protein";
    Supplement["SOY_PROTEIN"] = "soy_protein";
    Supplement["TAURINE"] = "taurine";
    Supplement["TURMERIC"] = "turmeric";
    Supplement["VEGAN_PROTEIN"] = "vegan_protein";
    Supplement["VITAMIN_C"] = "vitamin_c";
    Supplement["VITAMIN_D"] = "vitamin_d";
    Supplement["WEIGHT_GAINER"] = "weight_gainer";
    Supplement["WHEY_PROTEIN"] = "whey_protein";
    Supplement["ZINC"] = "zinc";
    Supplement["ZMA"] = "zma";
})(Supplement = exports.Supplement || (exports.Supplement = {}));
var Accreditation;
(function (Accreditation) {
    Accreditation["REPS"] = "reps";
    Accreditation["CIMSPA"] = "cimspa";
    Accreditation["NASM"] = "nasm";
    Accreditation["ACE"] = "ace";
    Accreditation["ISSA"] = "issa";
    Accreditation["NFPT"] = "nfpt";
    Accreditation["ACSM"] = "acsm";
})(Accreditation = exports.Accreditation || (exports.Accreditation = {}));
var BodyMeasurement;
(function (BodyMeasurement) {
    BodyMeasurement["WEIGHT"] = "weight";
    BodyMeasurement["BODY_FAT"] = "body_fat";
    BodyMeasurement["CHEST"] = "chest";
    BodyMeasurement["BUST"] = "bust";
    BodyMeasurement["UPPER_ARM"] = "upper_arm";
    BodyMeasurement["WAIST"] = "waist";
    BodyMeasurement["THIGHS"] = "thighs";
    BodyMeasurement["CALVES"] = "calves";
    BodyMeasurement["HIPS"] = "hips";
})(BodyMeasurement = exports.BodyMeasurement || (exports.BodyMeasurement = {}));
var ActivitySpecificMeasurement;
(function (ActivitySpecificMeasurement) {
    ActivitySpecificMeasurement["BENCH"] = "bench";
    ActivitySpecificMeasurement["SQUAT"] = "squat";
    ActivitySpecificMeasurement["DEADLIFT"] = "deadlift";
    ActivitySpecificMeasurement["PELOTON_RIDE"] = "peloton_ride";
    ActivitySpecificMeasurement["ROW2K"] = "row2k";
    ActivitySpecificMeasurement["ROW5K"] = "row5k";
    ActivitySpecificMeasurement["RUN5KM"] = "run5km";
    ActivitySpecificMeasurement["RUN10KM"] = "run10km";
})(ActivitySpecificMeasurement = exports.ActivitySpecificMeasurement || (exports.ActivitySpecificMeasurement = {}));
exports.AllTrackableMeasurements = Object.assign(Object.assign({}, BodyMeasurement), ActivitySpecificMeasurement);
// TODO: Currently, values have to be in ALL CAPS because of the file structure in Storage.
//   A DB migration alone would not be enough to fix this and requires changes to storage paths.
//   So this is a temporary solution and should be changed in the future.
var ImageAngle;
(function (ImageAngle) {
    ImageAngle["FRONT"] = "FRONT";
    ImageAngle["BACK"] = "BACK";
    ImageAngle["SIDE"] = "SIDE";
})(ImageAngle = exports.ImageAngle || (exports.ImageAngle = {}));
var Unit;
(function (Unit) {
    Unit["METRIC"] = "metric";
    Unit["IMPERIAL"] = "imperial";
})(Unit = exports.Unit || (exports.Unit = {}));
var Weight;
(function (Weight) {
    Weight["KG"] = "kg";
    Weight["LB"] = "lb";
})(Weight = exports.Weight || (exports.Weight = {}));
var Length;
(function (Length) {
    Length["CM"] = "cm";
    Length["IN"] = "in";
})(Length = exports.Length || (exports.Length = {}));
var Time;
(function (Time) {
    Time["SECS"] = "s";
    Time["MINS"] = "m";
    Time["HOURS"] = "h";
    Time["DAYS"] = "days";
    Time["WEEKS"] = "weeks";
    Time["MONTHS"] = "months";
    Time["YEARS"] = "years";
})(Time = exports.Time || (exports.Time = {}));
// eslint-disable-next-line no-unused-vars
exports.UnitPreferences = {
    [Unit.METRIC]: {
        unit: Unit.METRIC,
        weight: Weight.KG,
        height: Length.CM,
        measurement: Length.CM,
        duration: Time.MONTHS,
    },
    [Unit.IMPERIAL]: {
        unit: Unit.IMPERIAL,
        weight: Weight.LB,
        height: Length.IN,
        measurement: Length.IN,
        duration: Time.MONTHS,
    },
};
var PostPrivacy;
(function (PostPrivacy) {
    PostPrivacy["PRIVATE"] = "private";
    PostPrivacy["RESTRICTED"] = "restricted";
    PostPrivacy["PUBLIC"] = "public";
})(PostPrivacy = exports.PostPrivacy || (exports.PostPrivacy = {}));
var Gender;
(function (Gender) {
    Gender["MALE"] = "male";
    Gender["FEMALE"] = "female";
    Gender["OTHER"] = "other";
})(Gender = exports.Gender || (exports.Gender = {}));
var Help;
(function (Help) {
    Help["TRAINER"] = "trainer";
    Help["PLAN"] = "plan";
})(Help = exports.Help || (exports.Help = {}));
var TransformationStatus;
(function (TransformationStatus) {
    TransformationStatus["NORMAL"] = "normal";
    TransformationStatus["DELETED"] = "deleted";
    TransformationStatus["FLAGGED"] = "flagged";
})(TransformationStatus = exports.TransformationStatus || (exports.TransformationStatus = {}));
var UserAccountStatus;
(function (UserAccountStatus) {
    UserAccountStatus["NORMAL"] = "normal";
    UserAccountStatus["DEACTIVATED"] = "deactivated";
    UserAccountStatus["DELETED"] = "deleted";
})(UserAccountStatus = exports.UserAccountStatus || (exports.UserAccountStatus = {}));
var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus["NOT_VERIFIED"] = "not_verified";
    VerificationStatus["PENDING"] = "pending";
    VerificationStatus["VERIFIED"] = "verified";
})(VerificationStatus = exports.VerificationStatus || (exports.VerificationStatus = {}));
var InviteStatus;
(function (InviteStatus) {
    InviteStatus["PENDING"] = "pending";
    InviteStatus["ACCEPTED"] = "accepted";
    InviteStatus["REJECTED"] = "rejected";
})(InviteStatus = exports.InviteStatus || (exports.InviteStatus = {}));
var InviteResponse;
(function (InviteResponse) {
    InviteResponse["ACCEPTED"] = "accepted";
    InviteResponse["REJECTED"] = "rejected";
})(InviteResponse = exports.InviteResponse || (exports.InviteResponse = {}));
//# sourceMappingURL=constants.js.map